export const PATH_HOME = "/";
export const PATH_MONITORAGGIO = "/monitoraggio";
export const PATH_INFO = "/info";
export const PATH_PRIVACY_POLICY = "/info/privacyPolicy";
export const PATH_COOKIE_POLICY = "/info/cookiePolicy";
export const PATH_COLORI_TRIAGE = "/info/legendaColori";
export const PATH_FAQ = "/info/faq";
export const PATH_CONTATTI = "/info/contatti";

export const PATH_DICHIARAZIONE_ACCESSIBILITA = "https://form.agid.gov.it/view/60553ca0-9b81-11ef-9b46-ffb23288856e";
export const PATH_REGIONE = "https://www.regione.liguria.it/";
export const PATH_SAN_MARTINO = "https://www.ospedalesanmartino.it/it/";
export const PATH_ALISA = "https://www.alisa.liguria.it/";
export const PATH_LD = "https://www.liguriadigitale.it/";
export const GOOGLE_MAPS_BASE_URL = "https://www.google.it/maps/place/";
